import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { fetch_one, fetch_all } from "../../../../lib/v31lib";
import { loginAtom } from '../../../../lib/auth';
import { currentPracticeAtom } from '../../../../lib/practice';

import {
  Box,
  Button as Btn,
  Chip,
  CircularProgress,
  DialogActions,
  Grid,
  MenuItem,
  Tooltip,
} from '@mui/material';

import {
  Button,
  DatePicker,
  Dt,
  Editor,
  FileDrop,
  Select,
  TextInput,
  Typography
} from '../../../../components/v2/styled';

import { Advice } from '../../../../models/Advice';

const { DateTime } = require("luxon");

type Props = {
  onClick: (b:boolean) => void;
  open: boolean;
  setOpen: (b:boolean) => void;
  advice: Advice;
  clonedAdvice: Advice;
  setAdvice: (d:Advice) => void;
  loading?: boolean;
  isCompare?: boolean;
  activeCompare?: Advice;
};

export const CoachEditAdviceTab0: FunctionComponent<Props> = ({isCompare, activeCompare, loading, open, setOpen, advice, clonedAdvice, setAdvice, onClick}) => {
  const theme = useTheme();
  // const navigate = useNavigate();
  const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const {t, i18n} = useTranslation(['translations']);

  const [flickerEditor, setFlickerEditor] = useState<boolean>(false);

  

  return (<>
    {!!activeCompare && <Grid item xs={6}>
      <Typography variant="h4" sx={{textDecoration: 'underline'}}>{t("new_advices.detail.compare.title_current")}: {advice.identification} (<Dt o={advice.advice_date} />)</Typography>
    </Grid>}
    {!!activeCompare && <Grid item xs={6}>
      <Typography variant="h4" sx={{textDecoration: 'underline'}}>{t("new_advices.detail.compare.title_comparison")}: {activeCompare.identification} (<Dt d={activeCompare.advice_date} />)</Typography>
    </Grid>}

    <Grid item xs={12}>
      <Typography html sx={{
        borderRadius: 1,
        border: '1px solid transparent',
        borderColor: theme.palette.warning.main,
        padding: 2,
        textAlign: 'center'
      }}>{t("new_advices.detail.warnings.internal_stuff_reversed")}</Typography>
    </Grid>

    {!!activeCompare && <Grid item xs={2} md={2}>
      <TextInput
        id="idx"
        caption={t("client.models.advices.idx", "Index")}
        disabled
        placeholder={t("client.models.advices.placeholders.idx", "1")}
        value={activeCompare?.idx?.toString() || ""}
        onChange={(e) => {
          
        }}
      />
    </Grid>}
    {!!activeCompare && <Grid item xs={4} md={4}>
      <TextInput
        id="advdate"
        caption={t("coach.models.advices.advice_date", "Datum")}
        disabled
        value={DateTime.fromISO(activeCompare.advice_date).toFormat("dd/LL/y") || ''}
        onChange={(e) => {
          
        }}
      />
    </Grid>}

    <Grid item xs={!!activeCompare ? 6 : 12}>
      {!flickerEditor && <Editor
        advanced
        label={t("coach.models.advices.deals", "Afspraken")}
        value={advice?.deals || ""}
        outside_world
        onChange={(e) => {
          setAdvice({
            ...advice,
            deals: e
          });
        }}
      />}
    </Grid>
    {!!activeCompare && <Grid item xs={6}>
      {!flickerEditor && <Editor
        advanced
        disabled
        label={t("coach.models.advices.deals", "Afspraken")}
        value={activeCompare?.deals || ""}
        onChange={(e) => {
          
        }}
      />}
    </Grid>}
    {(!!advice.feedback_deals || !!activeCompare?.feedback_deals) && <>
      <Grid item xs={!!activeCompare ? 6 : 12}>
        <Typography sx={{fontSize: '0.7rem'}}>{t("coach.models.advices.feedback_deals", "Opmerking van de client (afspraken)")}</Typography>
        <Typography html sx={{marginTop: '-6px', paddingLeft: 2, borderLeft: '2px solid transparent', borderColor: theme.palette.primary.main}}>{advice.feedback_deals}</Typography>
      </Grid>
    </>}
    {!!activeCompare && (!!advice.feedback_deals || !!activeCompare?.feedback_deals) && <>
      <Grid item xs={6}>
        <Typography sx={{fontSize: '0.7rem'}}>{t("coach.models.advices.feedback_deals", "Opmerking van de client (afspraken)")}</Typography>
        <Typography html sx={{marginTop: '-6px', paddingLeft: 2, borderLeft: '2px solid transparent', borderColor: theme.palette.primary.main}}>{activeCompare.feedback_deals}</Typography>
      </Grid>
    </>}

    <Grid item xs={!!activeCompare ? 6 : 12}>
      {!flickerEditor && <Editor
        advanced
        disabled={!!isCompare}
        label={t("coach.models.advices.goals", "Doelstelling")}
        value={advice?.goals || ""}
        outside_world
        onChange={(e) => {
          setAdvice({
            ...advice,
            goals: e
          });
        }}
      />}
    </Grid>
    {!!activeCompare && <Grid item xs={6}>
      {!flickerEditor && <Editor
        advanced
        disabled
        label={t("coach.models.advices.goals", "Doelstelling")}
        value={activeCompare?.goals || ""}
        onChange={(e) => {
          
        }}
      />}
    </Grid>}
    {(!!advice.feedback_goals || !!activeCompare?.feedback_goals) && <>
      <Grid item xs={!!activeCompare ? 6 : 12}>
        <Typography sx={{fontSize: '0.7rem'}}>{t("coach.models.advices.feedback_goals", "Opmerking van de client (goals)")}</Typography>
        <Typography html sx={{marginTop: '-6px', paddingLeft: 2, borderLeft: '2px solid transparent', borderColor: theme.palette.primary.main}}>{advice.feedback_goals}</Typography>
      </Grid>
    </>}
    {!!activeCompare && (!!advice.feedback_goals || !!activeCompare?.feedback_goals) && <>
      <Grid item xs={12}>
        <Typography sx={{fontSize: '0.7rem'}}>{t("coach.models.advices.feedback_goals", "Opmerking van de client (goals)")}</Typography>
        <Typography html sx={{marginTop: '-6px', paddingLeft: 2, borderLeft: '2px solid transparent', borderColor: theme.palette.primary.main}}>{activeCompare.feedback_goals}</Typography>
      </Grid>
    </>}

    <Grid item xs={!!activeCompare ? 6 : 12}>
      {!flickerEditor && <Editor
        advanced
        disabled={!!isCompare}
        label={t("coach.models.advices.education", "Educatie")}
        value={advice?.education || ""}
        outside_world
        onChange={(e) => {
          setAdvice({
            ...advice,
            education: e
          });
        }}
      />}
    </Grid>
    {!!activeCompare && <Grid item xs={6}>
      {!flickerEditor && <Editor
        advanced
        disabled
        label={t("coach.models.advices.education", "Educatie")}
        value={activeCompare?.education || ""}
        onChange={(e) => {
          setAdvice({
            ...advice,
            education: e
          });
        }}
      />}
    </Grid>}
    {(!!advice.feedback_education || !!activeCompare?.feedback_education) && <>
      <Grid item xs={!!activeCompare ? 6 : 12}>
        <Typography sx={{fontSize: '0.7rem'}}>{t("coach.models.advices.feedback_education", "Opmerking van de client (educatie)")}</Typography>
        <Typography html sx={{marginTop: '-6px', paddingLeft: 2, borderLeft: '2px solid transparent', borderColor: theme.palette.primary.main}}>{advice.feedback_education}</Typography>
      </Grid>
    </>}
    {!!activeCompare && (!!advice.feedback_education || !!activeCompare?.feedback_education) && <>
      <Grid item xs={6}>
        <Typography sx={{fontSize: '0.7rem'}}>{t("coach.models.advices.feedback_education", "Opmerking van de client (educatie)")}</Typography>
        <Typography html sx={{marginTop: '-6px', paddingLeft: 2, borderLeft: '2px solid transparent', borderColor: theme.palette.primary.main}}>{activeCompare.feedback_education}</Typography>
      </Grid>
    </>}

    {!isCompare && <Grid item xs={!!activeCompare ? 6 : 12}>
      {/* <Dropzone
        filesLimit={5}
        maxFileSize={26214400}
        showFileNamesInPreview={true}
        showFileNames={true}
        initialFiles={this.state.active_advice.attachments ? this.state.active_advice.attachments.map((f) => f.attributes.url) : []}
        onChange={(files) => {
          this.setState({
            files: files
          });
        }}
      /> */}
      <Typography sx={{fontSize: '0.7rem'}}>{t("coach.models.advices.attachments", "Bijlagen")}</Typography>
      <FileDrop
        onDrop={acceptedFiles => {setAdvice({
          ...advice,
          items: acceptedFiles
        });}}
        multiple={true}
        outside_world
        maxSize={20 * 1000 * 1000}
        items={advice.items}
        dropText="Click/Drop"
        dropHint="All.: all files, < 10mb"
      />
    </Grid>}
    {!!activeCompare && <Grid item xs={12}></Grid>}
    <Grid item xs={!!activeCompare ? 6 : 12}>
      {(advice.attachments || []).map(item => <Tooltip title={<Box sx={{maxWidth: 300, maxHeight: 300}}><img src={item.url} style={{maxWidth: 280, maxHeight: 280, width: 'auto', height: 'auto'}} /></Box>}><Chip label={item.file_name} variant="outlined" color="primary" sx={{marginRight: 0.5}} onDelete={() => {setAdvice({...advice, attachments: advice.attachments.filter(fff => fff.id !== item.id)});}} /></Tooltip>)}
    </Grid>
    {!!activeCompare && <Grid item xs={12}>
      {(activeCompare.attachments || []).map(item => <Tooltip title={<Box sx={{maxWidth: 300, maxHeight: 300}}><img src={item.url} style={{maxWidth: 280, maxHeight: 280, width: 'auto', height: 'auto'}} /></Box>}><Chip label={item.file_name} variant="outlined" color="primary" sx={{marginRight: 0.5}} onDelete={() => {}} /></Tooltip>)}
    </Grid>}
  </>);
}
